import { render, staticRenderFns } from "./selectStatistics.vue?vue&type=template&id=45480186&scoped=true"
import script from "./selectStatistics.vue?vue&type=script&lang=js"
export * from "./selectStatistics.vue?vue&type=script&lang=js"
import style0 from "./selectStatistics.vue?vue&type=style&index=0&id=45480186&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45480186",
  null
  
)

export default component.exports